// Runtime feature flags. Deployed containers inject window._env_ from Cloud
// Run environment variables at startup (see docker-env-config.sh), so flags
// can be flipped per revision without rebuilding the bundle. `npm start`
// falls back to build-time REACT_APP_* values.

declare global {
  interface Window {
    _env_?: Record<string, string | undefined>;
  }
}

export const isOcAnalystChatEnabled = (): boolean => {
  const runtime = window._env_?.OC_ANALYST_CHAT_ENABLED;
  if (runtime !== undefined) {
    return runtime === "true";
  }
  return process.env.REACT_APP_OC_ANALYST_CHAT_ENABLED === "true";
};
